import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from '../../../../../core/service/v2/abstractRepositoryV2';
import {ReportDefinitionModel} from '../../../api/entity/reportDefinition.model';

@Injectable()
export class ReportDefinitionRepository extends AbstractRepositoryV2<ReportDefinitionModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('ReportDefinition', serviceElementsFactory, injector);
    }
}
